import React, { useState } from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePaginationState from "../../customHooks/usePaginationHook";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import usePostHook from "../../customHooks/usePostHook";
const TransactionComponent = loadable(
  () => import("../../components/Transaction")
);
type Props = {};

const Transaction = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dateStart = startDate
    ? moment(startDate).startOf("day").format("yyyy-MM-DDTHH:mm:ss")
    : null;
  const dateEnd = endDate
    ? moment(endDate).endOf("day").format("yyyy-MM-DDTHH:mm:ss")
    : null;

  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";

  const [activeTab, setActiveTab] = useState<any>("");
  const { data: accountData, isPending: accountLoading } = useGetHook({
    queryKey: ["account"],
    url: `${APIS.ACCOUNT}`,
    params: {},
  });
  const { data: orderData, isPending: orderLoading } = useGetHook({
    queryKey: [
      `transcation-${activeTab?.id}-${pageSize}-${offset}-${searchQuery}-${dateStart}-${dateEnd}`,
    ],
    url: `${APIS.TRANSACTION}`,
    params: {
      account: activeTab?.id,
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
      ...(dateStart &&
        dateEnd && { created__range: `${dateStart}, ${dateEnd}` }),
    },
  });
  const { isPostLoading, mutateAsync } = usePostHook({
    queryKey: ["add_cashout"],
    navigateURL: null,
  });
  const handleAddCashout = async (data: any, setOpenCashOut: any) => {
    const formData = {
      debit: data.debit,
      note: data.note,
    };
    const url = APIS.ADD_CASHOUT;
    try {
      const res = await mutateAsync({ url, formData });
      if (res.status === 200) {
        setOpenCashOut((pre: boolean) => !pre);
      }
    } catch (err) {
      console.error("Error creating category:", err);
    }
  };
  return (
    <TransactionComponent
      orderData={orderData}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      accountData={accountData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      offset={offset}
      setOffset={setOffset}
      orderLoading={orderLoading}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      handleAddCashout={handleAddCashout}
      isPostLoading={isPostLoading}
    />
  );
};

export default Transaction;
